import { IFormTemplateKey, useFormsTemplate } from '@commenda/api';
import { HumanFormStepHelper } from './human-form-step-helper';

interface UseHumanFormVersionStateParams {
  formId: string | undefined;
  keys: readonly IFormTemplateKey[];
}

/** Whether the step points at a superseded form: one whose key now points at a different live
 * version. The form is read only when it is not among the live ids the dropdown already has. */
export const useHumanFormVersionState = ({
  formId,
  keys,
}: UseHumanFormVersionStateParams) => {
  const hasFormId = formId !== undefined && formId !== '';
  const shouldReadForm =
    hasFormId &&
    keys.length > 0 &&
    !HumanFormStepHelper.isLiveFormId(keys, formId);
  const { template, isLoading, error } = useFormsTemplate(
    shouldReadForm ? formId : null
  );

  const supersededTemplate = shouldReadForm ? template : null;
  const keyLiveFormId = HumanFormStepHelper.findLiveFormIdForKey(
    keys,
    supersededTemplate?.key
  );
  const isSuperseded = keyLiveFormId !== null && keyLiveFormId !== formId;

  return {
    supersededTemplate,
    /** The id to repoint the step at; null unless the key's live form differs from the one selected. */
    liveFormId: isSuperseded ? keyLiveFormId : null,
    isLoading,
    error,
  };
};
